import { Stack } from '@fluentui/react';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { ErrorBoundary } from '@shared-legacy/lib/ui/components/ErrorBoundary/ErrorBoundary';
import { ProviderAppAuth } from '@shared-legacy/lib/ui/components/ProviderAppAuth/ProviderAppAuth';
import { H2OThemeProvider } from '@shared-legacy/ui-kit';
import { AppDesignBootstrap } from '@app/design/components/AppDesignBootstrap';
import { ProviderAppQueryClient } from '@app/providers/ProviderAppQueryClient';
import { BannerProvider, CloudPlatformDiscoveryConfig, CloudPlatformDiscoveryProvider } from '@shared/contexts';
import { DocsProvider } from '@shared/docs/DocsProvider';
import { ToastProvider } from '@shared/lib/ui/components-alpha';
import { stackStylesAppContainer } from '@shared/themes';

export interface AppProvidersProps {
  children: React.ReactNode;
  discovery: CloudPlatformDiscoveryConfig;
  auth: {
    authority: string;
    clientId: string;
  };
}

export const AppProviders = ({ children, discovery, auth }: AppProvidersProps) => (
  <CloudPlatformDiscoveryProvider discovery={discovery}>
    <ProviderAppAuth authority={auth.authority} client_id={auth.clientId}>
      <Stack styles={stackStylesAppContainer} data-test="app-main-container">
        <H2OThemeProvider>
          <ErrorBoundary>
            <ToastProvider>
              <ProviderAppQueryClient>
                <BrowserRouter>
                  <AppDesignBootstrap>
                    <BannerProvider>
                      <DocsProvider>{children}</DocsProvider>
                    </BannerProvider>
                  </AppDesignBootstrap>
                </BrowserRouter>
              </ProviderAppQueryClient>
            </ToastProvider>
          </ErrorBoundary>
        </H2OThemeProvider>
      </Stack>
    </ProviderAppAuth>
  </CloudPlatformDiscoveryProvider>
);
